<template>
    <div>
        <bxs-navbar v-if="is_preloaded && show_top_nav" />

        <!-- view -->
        <main
        v-if="is_preloaded"
        class="app__main">
            <router-view
            ref="view"
            v-slot="{ Component }">
                <!-- name="page"
                mode="out-in"
                appear -->
                <transition
                @enter="enter"
                @leave="leave"
                mode="out-in"
                appear>
                    <component
                    v-if="is_preloaded"
                    ref="page"
                    :key="$route.name"
                    :is="Component" />
                </transition>
            </router-view>
        </main>

        <bxs-bottom-nav v-if="is_preloaded && !!$api.auth.me && show_bottom_nav">
            <bxs-toolbar
            color="background"
            style="border-top: 1px solid rgba(0, 0, 0, 0.5);">
                <bxs-btn
                icon
                fab
                to="/">
                    <bxs-icon name="house"></bxs-icon>
                </bxs-btn>

                <bxs-spacer></bxs-spacer>

                <bxs-btn
                icon
                fab
                to="/works">
                    <bxs-icon name="search"></bxs-icon>
                </bxs-btn>

                <bxs-spacer></bxs-spacer>

                <bxs-menu min-height="35vh">
                    <template #activator="{ on }">
                        <bxs-btn
                        v-on="on"
                        fab
                        color="primary">
                            <bxs-icon name="plus-lg"></bxs-icon>
                        </bxs-btn>
                    </template>

                    <bxs-list>
                        <bxs-list-item
                        append-icon="plus"
                        to="/works/new/edit">Aggiungi opera</bxs-list-item>
                    </bxs-list>
                </bxs-menu>

                <bxs-spacer></bxs-spacer>

                <bxs-btn
                icon
                fab
                to="/me">
                    <bxs-icon name="person"></bxs-icon>
                </bxs-btn>

                <bxs-spacer></bxs-spacer>

                <bxs-btn
                icon
                fab
                disabled
                to="/me/settings">
                    <bxs-icon name="settings"></bxs-icon>
                </bxs-btn>
            </bxs-toolbar>
        </bxs-bottom-nav>

        <transition name="fade" mode="out-in">
            <bxs-loader
            v-if="is_loading"
            fullscreen></bxs-loader>
        </transition>

        <div
        v-if="$api.env !== 'development' && window_w >= 968"
        class="bxs-save-frame">
            <p>Desktop is not available</p>
        </div>
    </div>
</template>

<script>
import { gsap } from 'gsap'
import { mapState } from 'vuex'
import { fixVh } from '@/assets/libs/utils'

import Navbar from '@/components/layout/Navbar.vue'

export default {
    name: 'App',
    components: {
        'bxs-navbar': Navbar
    },
    data () {
        return {
            window_w: 0
        }
    },
    computed: {
        ...mapState({
            access: state => state.access,
            is_loading: state => state.is_loading,
            is_preloaded: state => state.is_preloaded
        }),
        show_top_nav () {
            const v = []
            return !this.$store.state.is_mobile && !v.includes(this.$route.name)
        },
        show_bottom_nav () {
            const v = []
            return !v.includes(this.$route.name)
        }
    },
    mounted () {
        this.play()
    },
    methods: {
        async play () {
            console.log(this.$api)

            this.resize()
            window.addEventListener('resize', this.resize)
            this.$store.commit('set_is_loading', true)

            if (this.$route.name !== 'ui_components') {
                await this.$api.auth.getAccess()

                if (this.$api.auth.me) {
                    await this.$api.getEnums()
                    await this.$router.push(sessionStorage.getItem('fp-laci-webapp_last_page') || '/')
                }
            }

            this.$api.on('access-token-expired', (evt, val) => {
                // alert('Access expired!')
                // this.$router.go()
            })

            this.$store.commit('set_is_preloaded', true)
            this.$store.commit('set_is_loading', false)
        },
        resize () {
            fixVh()
            this.$store.commit('resize')
            this.window_w = window.innerWidth
        },
        enter (el, next) {
            gsap.fromTo(el, {
                x: -10,
                autoAlpha: 0
            }, {
                x: 0,
                autoAlpha: 1,
                duration: 0.5,
                ease: 'expo.out',
                clearProps: 'all',
                onComplete: next
            })
        },
        leave (el, next) {
            gsap.fromTo(el, {
                x: 0,
                autoAlpha: 1
            }, {
                x: -10,
                autoAlpha: 0,
                duration: 0.4,
                ease: 'expo.in',
                onComplete: next
            })
        }
    }
}
</script>

<style lang="scss">
@import '@/assets/styles/index.scss';
</style>